import {
  PENDING_SIGNUP_STATUS,
  UserManagementApi,
} from '@orca/api-user-management';

interface PendingSignUpPending {
  signup_status: PENDING_SIGNUP_STATUS;
  pre_verified?: boolean;
}

export async function fetchAdminInvitationStatus(
  email: string
): Promise<PendingSignUpPending> {
  if (!email) {
    return Promise.resolve({ signup_status: PENDING_SIGNUP_STATUS.notFound });
  }
  // pendingSignup endpoint should be called always when the user is trying to sign up
  // to cover the case of a Agency admin with pending invitation, trying to signup from a normal sign up view
  // 200 - User found - {
  // "signup_status": "pending|registered",
  // "pre_verified": true|false,
  // }
  // 404 - User not found
  try {
    const pendingSignupResponse = await UserManagementApi.pendingSignup({
      email,
    });
    return pendingSignupResponse as PendingSignUpPending;
  } catch (error) {
    return { signup_status: PENDING_SIGNUP_STATUS.notFound };
  }
}
